import React from "react";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import TenderProcessTracker from "../../components/TenderProcessTracker/TenderProcessTracker";
import { useParams } from "react-router-dom";
import { ClientComparison }  from "../../components/TenderProcess"
import {
    ClientComparisonPageContainer,
} from "./ClientComparisonPage.styles";

export default function ClientComparisonPage() {
    const { tenderId, subStep } = useParams();
    return (
        <ClientComparisonPageContainer data-testid="main-content">
            <Breadcrumbs />
            <TenderProcessTracker />
            <ClientComparison tenderId={tenderId} subStep={subStep}/>
        </ClientComparisonPageContainer>
    );
}